import "./ToggleTabs.css";

import { ToggleTabsList } from "../../../models";
import { useToggleTabs } from "./useToggleTabs";

interface ToggleTabsProps {
  toggleTabsList: ToggleTabsList;
  onChange: (value: string) => void;
  currentTab?: string;
  size?: "small" | "medium";
  variant?: "default" | "roundedSquare";
  disabled?: boolean;
}

export const ToggleTabs = ({
  toggleTabsList,
  onChange,
  currentTab = toggleTabsList[0].label,
  size = "medium",
  variant = "default",
  disabled = false,
}: ToggleTabsProps): JSX.Element => {
  const { tabsRef, setValue, value } = useToggleTabs({ toggleTabsList, currentTab });

  return (
    <div
      className={`ToggleTabs ToggleTabs_size_${size} ToggleTabs_variant_${variant}${disabled ? " ToggleTabs_disabled" : ""}`}
      role="tablist"
    >
      <div
        className="ToggleTabs_indicator"
        aria-hidden="true"
        // eslint-disable-next-line no-return-assign
        ref={(el) => (tabsRef.current[toggleTabsList.length] = el)}
      />
      {toggleTabsList.map((tab, index) => (
        <button
          // eslint-disable-next-line no-return-assign
          ref={(el) => (tabsRef.current[index] = el)}
          key={tab.label}
          type="button"
          role="tab"
          aria-selected={value === tab.label}
          disabled={disabled}
          onClick={() => {
            setValue(tab.label);
            onChange(tab.label);
          }}
          className={`ToggleTabsTab${value === tab.label ? " ToggleTabsTab_active" : ""}`}
        >
          <span className="TabLabel">
            {tab.label}
            {tab.count && <span className="CountSpan"> ({tab.count})</span>}
          </span>
        </button>
      ))}
    </div>
  );
};
